import { RawPostViewerApp } from "./main";
import { registerComponent } from "lib/components";

registerComponent({ RawPostViewerApp });
